// used in modal and popover
export const SUBSIDY_INFO_MESSAGE = '(v)COW token holders are eligible for a fee discount'
export const COW_SUBSIDY_DATA: [string, number][] = [
  ['0', 0],

  // 1,000
  ['1000000000000000000000', 5],

  // 10,000
  ['10000000000000000000000', 10],

  // 100,000
  ['100000000000000000000000', 20],

  // 1,000,000
  ['1000000000000000000000000', 40],
]
